export const CACHE_KEY_LIST_CLIENTS_TREE = 'clients-tree';
export const CACHE_KEY_CLIENT_TREE = 'clients-tree-one';
export const ROUTE_PATH_CLIENTS_TREE = '/clients/tree-list';
export const TRANSLATION_PREFIX_CLIENTS_TREE = 'clients';

